import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Actions/userActions";
import { BRAND_LOGO } from "../config/Constant";
import CategoryNav from "../shared/components/Nav/CategoryNav";

const Header = ({ onSearch }) => {
  const [keyword, setKeyword] = useState("");

  const dispatch = useDispatch();
  let history = useHistory();

  const curPin = JSON.parse(localStorage.getItem("curPin"));

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const trimmed = keyword.trim();

    // Pass keyword to parent
    if (onSearch) {
      onSearch(trimmed);
    }

    // Navigation
    if (trimmed) {
      history.push(`/search/${trimmed}`);
    } else {
      history.push("/");
    }
  };

  const setKeywordHandler = (e) => {
    const value = e.target.value;
    setKeyword(value);

    // When native 'X' is clicked, the value becomes empty
    if (value.trim() === "") {
      if (onSearch) {
        onSearch(""); // Clear parent filters
      }
      history.push("/"); // Return to home page
    }
  };



  return (
    <div>
      {/* Top Header */}
      <div className="Announcement">
        <div className="container">
          <div className="row">
            <CategoryNav />
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="header">
        <div className="container">
          {/* PC HEADER */}
          <div className="pc-header">
            <div className="row">
              <div className="col-md-3 col-4 d-flex align-items-center">
                <Link className="navbar-brand" to="/">
                  <img alt="logo" src={BRAND_LOGO} />
                </Link>

                <span className="header-delivery-content" title="Min 3 Hours">
                  {curPin?.dTime ? (
                    <span>Delivery in {curPin?.dTime} Min*</span>
                  ) : (
                    <span>Same Day Delivery*</span>
                  )}
                </span>
              </div>

              <div className="col-md-6 col-8 d-flex align-items-center">
                <form onSubmit={submitHandler} className="input-group">
                  <input
                    type="search"
                    className="form-control rounded search"
                    placeholder="Search"
                    value={keyword}
                    onChange={setKeywordHandler}
                  />
                  <button type="submit" className="search-button">
                    Search
                  </button>
                </form>
              </div>

              <div className="col-md-3 d-flex align-items-center justify-content-end Login-Register">
                {userInfo ? (
                  <div className="btn-group">
                    <button
                      type="button"
                      className="name-button dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Hi, {userInfo.name}
                    </button>
                    <div className="dropdown-menu">
                      <Link className="dropdown-item" to="/profile">
                        Profile
                      </Link>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={logoutHandler}
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <Link to="/register">Register</Link>
                    <Link to="/login-otp">Login</Link>
                  </>
                )}

                <Link to="/cart" style={{ marginRight: '15px' }}>
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>
            </div>
          </div>

          {/* MOBILE HEADER */}
          <div className="mobile-header">
            <div className="row">
              <div className="col-6 d-flex align-items-center">
                <Link className="navbar-brand" to="/">
                  <img alt="logo" src={BRAND_LOGO} />
                </Link>
                <span
                  className="mobile-header-delivery-content"
                  title="Min 3 Hours"
                >
                  {curPin?.dTime ? (
                    <span>Delivery in {curPin?.dTime} Min*</span>
                  ) : (
                    <span>Same Day Delivery*</span>
                  )}
                </span>
              </div>

              <div className="col-6 d-flex align-items-center justify-content-end Login-Register">
                {userInfo ? (
                  <div className="btn-group">
                    <button
                      type="button"
                      className="name-button dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="fas fa-user"></i>
                    </button>
                    <div className="dropdown-menu">
                      <Link className="dropdown-item" to="/profile">
                        Profile
                      </Link>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={logoutHandler}
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="btn-group">
                    <button
                      type="button"
                      className="name-button dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="fas fa-user"></i>
                    </button>
                    <div className="dropdown-menu">
                      <Link className="dropdown-item" to="/login-otp">
                        Login
                      </Link>
                      <Link className="dropdown-item" to="/register">
                        Register
                      </Link>
                    </div>
                  </div>
                )}

                <Link to="/cart" className="cart-mobile-icon" style={{ marginRight: '15px' }}>
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>

              <div className="col-12 d-flex align-items-center search-input-mobile">
                <form onSubmit={submitHandler} className="input-group">
                  <input
                    type="search"
                    className="form-control rounded search"
                    placeholder="Search"
                    value={keyword}
                    onChange={setKeywordHandler}
                  />
                  <button type="submit" className="search-button">
                    Search
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
